import { createContext, useContext } from "react";
import defaultTheme from '@theme/defaultTheme';

export type GlobalContent = {
  themeData: any,
  customTheme: any,
  guest: any,
  setThemeData:(c: any) => void,
  setCustomTheme:(c: any) => void,
  setGuest: (c: any) => void,
}
export const MyGlobalContext = createContext<GlobalContent>({
  customTheme: null,
  themeData: defaultTheme, // set a default value
  guest: null,
  setThemeData: (a : any) => void{},
  setCustomTheme: (a : any) => void{},
  setGuest:(a: any) => void{},
})
export const useGlobalContext = () => useContext(MyGlobalContext)